module.exports = __webpack_public_path__ + "img/customerBindHandPic1.733d692a.png";